module.exports = __webpack_public_path__ + "img/flag-04.57429250.svg";